import axios from "axios";

const Url = process.env.REACT_APP_URl;
const DevUrl = process.env.REACT_APP_URl;

export const AccountService = async (accountObject: any) => {
  const response = await axios.post(`${Url}/accounts`, accountObject, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;;
}

export const getUserId = () => {
  const user: any = getCurrentUser();
  return user.user_id;
}

export const getCurrentUser = () => {
  const token = localStorage.getItem("usertoken");
  let payload
  if (token) {
    payload = token.split('.')[1]

    try {
      payload = window.atob(payload)
    } catch (err) {
      return null
    }
    return JSON.parse(payload).sub
  } else {
    return null
  }
};


export const getCheckToken= async () => {
  const response = await axios.get(`${Url}/check-token`, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const getUserDetails = async () => {
  const response = await axios.post(`${Url}/get_user_details`, {}, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const GetAccount = () => {
  const apiUrl = Url + "/get_account";
  return axios.get(apiUrl, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.log(error.data)
  })
}


export const getAccessRights = async () => {
  const response = await axios.get(`${DevUrl}/getAccessRights`, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}